


































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Carousel, Slide } from 'vue-carousel';
import CorrectionBannerScore from '@/components/CorrectionsBannerScore.vue';
import CorrectionModel from '@/dex-shared/models/CorrectionModel';
import ScoreChart from './ScoreChart.vue';

export default Vue.extend({
  components: {
    CorrectionBannerScore,
    ScoreChart,
    Carousel,
    Slide,
  },
  computed: {
    ...mapGetters({
      corrections: 'corrections',
    }),
    scoreChange(): number {
      let oldCorrections = this.corrections.slice(1);
      let oldAverage =
        oldCorrections.reduce(
          (accumulator: number, current: CorrectionModel) =>
            accumulator + current.score,
          0,
        ) / oldCorrections.length;
      return Math.floor(this.overallScore - oldAverage);
    },
    lastCorrections(): CorrectionModel[] {
      return this.corrections.slice(0, 5);
    },
    reversedLastCorrections(): CorrectionModel[] {
      // empty concat to avoid inplace mutation
      return this.lastCorrections.concat().reverse();
    },
    overallScore(): number {
      return Math.floor(
        this.corrections.reduce(
          (accumulator: number, current: CorrectionModel) =>
            accumulator + current.score,
          0,
        ) / this.corrections.length,
      );
    },
  },
});
